import {
  startTour,
  reabrirTour,
  podeReabrirTour,
  runContext,
  replayFeature,
  listHelpOptions,
  stopFeatures,
  showHintSet,
  resolveFeatureTourUserId,
} from '@/feature-tours';

/**
 * Mixin Options API — a view declara contexto; o core orquestra tours/hints.
 *
 *   this.rodarContextoFeatures('auction.situation', { situation, logged })
 *   this.opcoesAjudaContexto('auction.recursos', ctx, { scope: 'form-razoes' })
 *   this.reabrirFeature('prazos-recursais', ctx)
 */
export default {
  methods: {
    _featureTourUserId() {
      return resolveFeatureTourUserId(this.$store);
    },
    _featureTourCtx(ctx = {}) {
      return {
        logged: Boolean(this.$store?.getters?.getLogged),
        ...ctx,
      };
    },
    /** @deprecated Prefer rodarContextoFeatures */
    iniciarTourSeNecessario(tourId, ctx = {}) {
      const userId = this._featureTourUserId();
      return startTour(tourId, userId, this._featureTourCtx(ctx));
    },
    /** @deprecated Prefer opcoesAjudaContexto / reabrirFeature */
    podeReabrirTourAgora(tourId, ctx = {}) {
      const userId = this._featureTourUserId();
      return podeReabrirTour(tourId, userId, this._featureTourCtx(ctx));
    },
    /** @deprecated Prefer reabrirFeature */
    reabrirTourSePossivel(tourId, ctx = {}) {
      const userId = this._featureTourUserId();
      return reabrirTour(tourId, userId, this._featureTourCtx(ctx));
    },
    /** @deprecated Prefer rodarContextoFeatures */
    mostrarHintsSeNecessario(hintSetId, ctx = {}) {
      const userId = this._featureTourUserId();
      return showHintSet(hintSetId, userId, this._featureTourCtx(ctx));
    },
    ocultarHintsAtivos() {
      stopFeatures();
    },
    /**
     * Dispara a primeira feature elegível do contexto.
     * @param {string} contextId
     * @param {object} ctx
     * @param {{ prepares?: object, scope?: string, featureIds?: string[] }} [options]
     */
    rodarContextoFeatures(contextId, ctx = {}, options = {}) {
      const userId = this._featureTourUserId();
      return runContext(contextId, userId, this._featureTourCtx(ctx), options);
    },
    /**
     * Opções para FeatureTourHelp a partir do registry do contexto.
     */
    opcoesAjudaContexto(contextId, ctx = {}, options = {}) {
      const userId = this._featureTourUserId();
      return listHelpOptions(contextId, userId, this._featureTourCtx(ctx), options);
    },
    /**
     * Reabre tour/hint sob demanda (ícone de ajuda).
     */
    reabrirFeature(featureId, ctx = {}, options = {}) {
      const userId = this._featureTourUserId();
      return replayFeature(featureId, userId, this._featureTourCtx(ctx), options);
    },
  },
};
